export class ElementBuilder {
    static create(tagName, options = {}) {
        const element = document.createElement(tagName);

        if (options.className) {
            // Boşluk içeren class'ları ayrı ayrı ekle
            options.className.split(' ').forEach(cls => {
                if (cls) element.classList.add(cls);
            });
        }

        if (options.text) {
            element.textContent = options.text;
        }

        if (options.html) {
            element.innerHTML = options.html;
        }

        if (options.attributes) {
            Object.entries(options.attributes).forEach(([key, value]) => {
                element.setAttribute(key, value);
            });
        }

        if (options.children) {
            options.children.forEach(child => {
                if (child instanceof Element) {
                    element.appendChild(child);
                } else if (typeof child === 'string') {
                    element.appendChild(document.createTextNode(child));
                }
            });
        }

        if (options.onclick) {
            element.addEventListener('click', options.onclick);
        }

        if (options.style) {
            Object.assign(element.style, options.style);
        }

        return element;
    }

    static createIcon(name, options = {}) {
        const icon = this.create('i', {
            className: `fas fa-${name}`,
            ...options
        });
        return icon;
    }
}